import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./RequireAuth.module.css";
import {
  PatternlibIcon,
  PatternlibButton,
  PatternlibTeaser,
} from "@liebherr/patternlib-react";
import { useLocalStorage } from "../../helpers/helpers";
import { useAuth } from "react-oidc-context";
import PropTypes from "prop-types";
import Separator from "../separator/Separator";
import { useTranslation } from "react-i18next";
import placeholder from "../../img/Konfigurator_Pressemitteilung.jpg";

const RequireAuth = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();
  const key = location.state?.key;
  const [latestConfig, setLatestConfig] = useLocalStorage("key", null);
  const { t } = useTranslation();

  useEffect(() => {
    if (key !== null) {
      // save key to local storage to persist data
      setLatestConfig([key, "/downloads"]);
    }
  }, []);

  if (!auth.isAuthenticated) {
    return (
      <div className={styles.container}>
        <PatternlibTeaser
          image={placeholder}
          headline={t("loginTitle")}
          image-object-fit="cover"
          text={t("loginText")}
        >
          <Separator space="xxs"></Separator>
          <div className={styles.buttonWrapper}>
            <PatternlibButton
              onClick={() => {
                auth.signinRedirect();
              }}
              label={t("login")}
              type="primary"
              size="small"
              icon-position="right"
            >
              <PatternlibIcon icon-name="exit" size="24px" slot="icon" bold />
            </PatternlibButton>
          </div>
          <Separator space="s"></Separator>
          <div className={styles.register}>
            <p className={styles.registertext}>{t("registerText")}</p>
            <a
              className={styles.registerlink}
              href="https://logintst.liebherr.com/profile/signup"
            >
              {t("registerLink")}
            </a>
          </div>
        </PatternlibTeaser>
      </div>
    );
  }

  return children;
};

RequireAuth.propTypes = {
  children: PropTypes.any,
};

export default RequireAuth;
